import axios from "axios";
import React, { useState } from "react";
import clientConfig from "../../env";
import { useSelector } from "react-redux";

function EventForm() {
  const [topicName, setTopicName] = useState("");
  const [error, setError] = useState("");
  const [eventSubmitted, setEventSubmitted] = useState(false);
  const [sumittedSuccessfully, setSumittedSuccessfully] = useState(false);

  const token = useSelector((state) => state.user.token);
  const userId = useSelector((state) => state.user.userId);

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value) {
      setError("");
    } else {
      setError("Please enter Topic name");
    }
    setTopicName(value);
  };

  const handleTopicFormSubmission = async (event) => {
    setEventSubmitted(true);
    try {
      event.preventDefault();
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      await axios.post(
        `${clientConfig.siteUrl}wl/v1/submitted-event`,
        {
          topic_name: topicName,
          user_id: userId,
          httpURL: window.location.origin,
        },
        {
          headers,
        }
      );
      setSumittedSuccessfully(true);
      setEventSubmitted(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="events-border rounded py-3 px-4">
      <h3 className="mb-4">Submit Your Topic</h3>

      {sumittedSuccessfully ? (
        <>
          <h4 className="text-success">Thank You!</h4>
          <p>
            Your topic has been submitted for review. Once approved, it will be
            posted for voting.
          </p>
        </>
      ) : (
        <form className="text-center" onSubmit={handleTopicFormSubmission}>
          <div>
            <input
              type="text"
              className="form-control text-center"
              name="event-name"
              placeholder="Submit a Topic Here"
              onChange={handleInputChange}
              value={topicName}
              maxLength={75}
            />
            {error ? <small className="text-danger">{error}</small> : ""}
          </div>
          <button
            className="btn btn-primary px-5 rounded-10 mt-3"
            disabled={!topicName.length || eventSubmitted}
          >
            Submit
          </button>
        </form>
      )}
    </div>
  );
}

export default EventForm;
